/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface VisiteClasseSearch
 */
export interface VisiteClasseSearch {
    /**
     * 
     * @type {number}
     * @memberof VisiteClasseSearch
     */
    idVisite?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisiteClasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof VisiteClasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteClasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteClasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof VisiteClasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof VisiteClasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the VisiteClasseSearch interface.
 */
export function instanceOfVisiteClasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisiteClasseSearchFromJSON(json: any): VisiteClasseSearch {
    return VisiteClasseSearchFromJSONTyped(json, false);
}

export function VisiteClasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisiteClasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idVisite': !exists(json, 'idVisite') ? undefined : json['idVisite'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function VisiteClasseSearchToJSON(value?: VisiteClasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idVisite': value.idVisite,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

